import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const ASSETS_URL = "https://subk.education.com.ly/back/api/fixed-assets";
const DEPRECIATION_URL = "https://subk.education.com.ly/back/api/depreciations-search";
  
function DepreciationPage() {
  const navigate = useNavigate(); // Use useNavigate hook for navigation

   ///////////////////////////////////////////////////////////
   const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
   function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'DepreciationPage';
  const actionsForPage = getActionsForPage(pageName);

///////////////////////////////////
  const [assets, setAssets] = useState([]);
  const [depreciations, setDepreciations] = useState([]);
  const [filters, setFilters] = useState({
    AssetID: "",
    AccountID: "",
    StartDate: ""
  });
  const fetchd = async () => {
      try {
        const res = await axios.get('https://subk.education.com.ly/back/api/depreciations');
        //setAssets(res.data);
      } catch (err) {
        console.error(err);
      }
    };
  // جلب الأصول
  useEffect(() => {
    const fetchAssets = async () => {
      try {
        const res = await axios.get(ASSETS_URL);
        setAssets(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchAssets();
    fetchd()
  }, []);

  // جلب تقرير الاستهلاك
  useEffect(() => {
    const fetchDepreciations = async () => {
      try {
        const params = {};
        if (filters.AssetID) params.AssetID = filters.AssetID;
        if (filters.AccountID) params.AccountID = filters.AccountID;
        if (filters.StartDate) params.StartDate = filters.StartDate;
  if (Object.keys(params).length === 0) {
        setDepreciations([]); // فضي الجدول
        return;
      }
        const res = await axios.get(DEPRECIATION_URL, { params });
        setDepreciations(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchDepreciations();
  }, [filters]);

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleClearFilter = () => {
    setFilters({ AssetID: "", AccountID: "", StartDate: "" });
  };
const [company, setCompany] = useState({});
  
     const userdata = localStorage.getItem('USER_data');
    const userData = JSON.parse(userdata);
    const userid = userData.id;
  
    // Fetch company data from localStorage
     
  // Initialize hallData with company data and user id when company is set
 
  // ترحيل الاستهلاك (Post) لكل أصل
  const handlePost = async (id) => {
    try {
      await axios.post(`https://subk.education.com.ly/back/api/depreciations/${id}/post`, {
      UserID: userid,   // هنا تبعت الـ UserID
    });
      alert("تم ترحيل الإهلاك بنجاح!");
    } catch (err) {
      console.error(err);
      alert("حدث خطأ أثناء ترحيل الإهلاك");
    }
  };

  return (
    <div className="container-fluid">
      <Row>
        <Col lg="12">
          <div className="card p-3">
            <h4 className="mb-3">تقرير الإهلاك / الإطفاء</h4>

            {/* الفلاتر */}
            <div className="row g-3 mb-3">
              <div className="col-md-3">
                <select
                  name="AssetID"
                  value={filters.AssetID}
                  onChange={handleFilterChange}
                  className="form-control"
                >
                  <option value="">-- اختر الأصل --</option>
                  {assets.map(a => (
                    <option key={a.AssetID} value={a.AssetID}>{a.AssetName}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <input
                  type="date"
                  name="StartDate"
                  value={filters.StartDate}
                  onChange={handleFilterChange}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <button className="btn btn-secondary" onClick={handleClearFilter}>مسح الفلتر</button>
              </div>
            </div>

            {/* جدول الاستهلاك */}
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>الرقم</th>
                    <th>الأصل</th>
                    <th>من</th>
                     <th>قيمة الاستهلاك</th>
                    <th>الإجراءات</th>
                  </tr>
                </thead>
                <tbody>
  {depreciations.length > 0 ? (
    depreciations.map(dep => {
      // 1. استخراج شهر وسنة من StartDate
      const depDate = new Date(dep.UsefulLifeYears);
      const depMonth = depDate.getMonth();
      const depYear = depDate.getFullYear();

      // 2. تاريخ اليوم
      const now = new Date();
      const currentMonth = now.getMonth();
      const currentYear = now.getFullYear();

      // 3. تحقق إذا تم الترحيل لهذا الشهر
      const isFinalized = dep.IsFinalized === 1 || (depMonth === currentMonth && depYear === currentYear);

      return (
        <tr key={dep.ID}>
          <td>{dep.ID}</td>
          <td>{dep.fixedassets?.AssetName || "-"}</td>
          <td>{dep.StartDate}</td>
           <td>{dep.AccumulatedAmount}</td>
          <td>
            {!isFinalized && (
              <button
                className="btn btn-success btn-sm"
                onClick={() => handlePost(dep.ID)}
              >
                ترحيل
              </button>
            )}
            {isFinalized && <span className="text-muted">مُرحّل</span>}
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="6">لا توجد بيانات لعرضها.</td>
    </tr>
  )}
</tbody>

   {/* {depreciations.length > 0 ? (
    depreciations.map(dep => (
      <tr key={dep.ID}>
        <td>{dep.ID}</td>
        <td>{dep.fixedassets?.AssetName || "-"}</td>
        <td>{dep.StartDate}</td>
         <td>{dep.AccumulatedAmount}</td>
        <td>
          <button className="btn btn-success btn-sm" onClick={() => handlePost(dep.ID)}>ترحيل</button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6">لا توجد بيانات لعرضها.</td>
    </tr>
  )} */}
 
              </table>
            </div>

          </div>
        </Col>
      </Row>
    </div>
  );
}

export default DepreciationPage;
